{
  "pt_BR": "casais",
  "cs_CZ": "pary",
  "da_DK": "par",
  "de_DE": "paare",
  "en_GB": "couples",
  "es_ES": "parejas",
  "fi_FI": "parit",
  "fr_FR": "couples",
  "it_IT": "coppie",
  "ja_JP": "kappuru",
  "ko_KR": "keopeul",
  "nl_NL": "stellen",
  "nb_NO": "par",
  "pl_PL": "pary",
  "pt_PT": "casais",
  "ru_RU": "pary",
  "sv_SE": "par",
  "tr_TR": "ciftler",
  "zh_CN": "fuqi"
}
